import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { LinkIcon, ListOrderedIcon, ListBulletIcon, QuoteIcon, CodeIcon } from "../../icons";

// Presentational toolbar with active-state indicators.
export default function FormattingToolbar({
  onBold,
  onItalic,
  onStrike,
  onLink,
  onOrdered,
  onBulleted,
  onQuote,
  onCode,
  isBold = false,
  isItalic = false,
  isStrike = false,
  isLink = false,
  isOrderedList = false,
  isBulletedList = false,
  isQuote = false,
  isCode = false,
}) {
  const { t } = useTranslation();
  const activeClass = (isActive) => `composer-v2__tool${isActive ? ' composer-v2__tool--active' : ''}`;
  // Prevent toolbar buttons from stealing focus from the editor so selection stays intact
  const keepSelection = (e) => { e.preventDefault(); };
  const labels = {
    toolbar: t("composer.formatting.toolbar", "Formatting options"),
    bold: t("composer.formatting.bold", "Bold"),
    italic: t("composer.formatting.italic", "Italic"),
    strike: t("composer.formatting.strikethrough", "Strikethrough"),
    link: t("composer.formatting.link", "Insert link"),
    ordered: t("composer.formatting.numberedList", "Numbered list"),
    bulleted: t("composer.formatting.bulletedList", "Bulleted list"),
    quote: t("composer.formatting.quote", "Quote"),
    code: t("composer.formatting.inlineCode", "Inline code"),
  };

  return (
    <div className="composer-v2__toolbar" aria-label={labels.toolbar}>
      <button type="button" title={labels.bold} className={activeClass(isBold)} aria-label={labels.bold} aria-pressed={Boolean(isBold)} onMouseDown={keepSelection} onClick={onBold}>
        <strong>B</strong>
      </button>
      <button type="button" title={labels.italic} className={activeClass(isItalic)} aria-label={labels.italic} aria-pressed={Boolean(isItalic)} onMouseDown={keepSelection} onClick={onItalic}>
        <em>I</em>
      </button>
      <button type="button" title={labels.strike} className={activeClass(isStrike)} aria-label={labels.strike} aria-pressed={Boolean(isStrike)} onMouseDown={keepSelection} onClick={onStrike}>
        <span style={{ textDecoration: "line-through" }}>S</span>
      </button>
      <span className="composer-v2__divider" aria-hidden="true" />
      <button type="button" title={labels.link} className={activeClass(isLink)} aria-label={labels.link} aria-pressed={Boolean(isLink)} onMouseDown={keepSelection} onClick={onLink}>
        <LinkIcon />
      </button>
      <button type="button" title={labels.ordered} className={activeClass(isOrderedList)} aria-label={labels.ordered} aria-pressed={Boolean(isOrderedList)} onMouseDown={keepSelection} onClick={onOrdered}>
        <ListOrderedIcon />
      </button>
      <button type="button" title={labels.bulleted} className={activeClass(isBulletedList)} aria-label={labels.bulleted} aria-pressed={Boolean(isBulletedList)} onMouseDown={keepSelection} onClick={onBulleted}>
        <ListBulletIcon />
      </button>
      <button type="button" title={labels.quote} className={activeClass(isQuote)} aria-label={labels.quote} aria-pressed={Boolean(isQuote)} onMouseDown={keepSelection} onClick={onQuote}>
        <QuoteIcon />
      </button>
      <button type="button" title={labels.code} className={activeClass(isCode)} aria-label={labels.code} aria-pressed={Boolean(isCode)} onMouseDown={keepSelection} onClick={onCode}>
        <CodeIcon />
      </button>
    </div>
  );
}

FormattingToolbar.propTypes = {
  onBold: PropTypes.func,
  onItalic: PropTypes.func,
  onStrike: PropTypes.func,
  onLink: PropTypes.func,
  onOrdered: PropTypes.func,
  onBulleted: PropTypes.func,
  onQuote: PropTypes.func,
  onCode: PropTypes.func,
  isBold: PropTypes.bool,
  isItalic: PropTypes.bool,
  isStrike: PropTypes.bool,
  isLink: PropTypes.bool,
  isOrderedList: PropTypes.bool,
  isBulletedList: PropTypes.bool,
  isQuote: PropTypes.bool,
  isCode: PropTypes.bool,
};
